<template>
  <v-dialog v-model="$root.confirm.isVisible" persistent>
    <v-card>
      <v-toolbar class="trHeader" style="height: 40px;">
        <v-toolbar-title class="white--text" style="text-align:center;">{{$root.confirm.title}}</v-toolbar-title>
      </v-toolbar>
      <v-flex>
        <v-card-text v-html="$root.confirm.question"></v-card-text>
      </v-flex>
      <v-flex actions>
        <v-btn outline small class="green green--text ml-3" @click.native="confirmed(true)">
          כן
          <!--<v-icon left>check</v-icon>-->
        </v-btn>
        <v-btn outline small class="red red--text ml-2" @click.native="confirmed(false)">
          לא
          <!--<v-icon left>block</v-icon>-->
        </v-btn>
      </v-flex>
    </v-card>
  </v-dialog>
</template>
<script>

  export default {
    name: 'PopupConfim',
    data() {
      return {
      }
    },
    created() {
      this.$Log("Vue [PopupConfim] is created ...");
    },
    ready() {
      this.$Log("Vue [PopupConfim] is ready ...");
    },
    mounted() {
      this.$Log("Vue [PopupConfim] is mounted ...");
    },
    updated() {
      this.$Log("Vue [PopupConfim] is updated ...");
    },
    methods: {
      confirmed(val) {
        this.$root.confirm = {
          isVisible: false,
          title: '',
          question: '',
          caller: this.$root.confirm.caller,
          isConfirmed: val
        };
      },
    }
  }

</script>
<style></style>



// WEBPACK FOOTER //
// PopupConfim.vue?44b40f0a